import { combineReducers } from 'redux';

import { reducer as clientContacts } from './State/clientContacts';

export default combineReducers({
  clientContacts
})
